export const REG_NUMBER_MAX = 10;
export const REG_NUMBER_MAX_CHARACTERS = 7;
export const REG_NUMBER_MIN = 2;
export const MILEAGE = 6;
export const BUSINESS_MILEAGE = 5;
export const NAME = 50;
export const DAY = 2;
export const MONTH = 2;
export const YEAR = 4;
export const CHILDREN = 1;
export const TELEPHONE = 12;
export const POSTCODE_MAX = 8;
export const POSTCODE_MIN = 5;
export const EMAIL = 50;
export const ONE_TIME_PASSWORD = 6;

export const BUILD_SUMS_INS_MAX = 8;
